import { render, staticRenderFns } from "./MatchingHistory.vue?vue&type=template&id=3872339d&"
import script from "./MatchingHistory.vue?vue&type=script&lang=js&"
export * from "./MatchingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports